<template>
  <div id="AddTeacher" class="well" style="padding: 0 1em">
    <b-tabs content-class="mt-3">
      <b-tab title="教師帳號單筆輸入" active>
        <div>
          <div class="course_title">新增教師資料</div>

          <div class="form-group">
            <table class="table" style="width: auto; align: left">
              <tbody>
                <tr>
                  <td colspan="4" align="left">
                    <span style="color: #f00"
                      ><span style="color: #f00">＊</span>為必填項目。</span
                    >
                  </td>
                </tr>

                <tr align="left">
                  <td><span class="red_star">＊</span>教師帳號(身分證字號)</td>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputData.idNo"
                      required
                    />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr align="left">
                  <td><span class="red_star">＊</span>姓名</td>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputData.name"
                      required
                    />
                  </td>
                  <td class="td_left"></td>
                  <td></td>
                </tr>
                <tr align="left">
                  <td><span class="red_star">＊</span>職稱</td>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputData.jobTitle"
                      required
                    />
                  </td>
                  <td class="td_left"></td>
                  <td></td>
                </tr>
                <tr align="left">
                  <td><span class="red_star">＊</span>服務單位</td>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputData.serviceUnit"
                      required
                    />
                  </td>
                  <td class="td_left"></td>
                  <td></td>
                </tr>
                <tr align="left">
                  <td><span class="red_star">＊</span>連絡電話</td>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputData.cellPhone"
                      required
                    />
                  </td>
                  <td class="td_left"></td>
                  <td></td>
                </tr>
                <tr align="left">
                  <td><span class="red_star">＊</span>Email</td>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputData.email"
                      required
                    />
                  </td>
                  <td class="td_left"></td>
                  <td></td>
                </tr>

                <tr style="text-align: center">
                  <td colspan="4" align="center">
                    <button
                      class="btn active bg-info text-white rounded"
                      @click="AddociaRepTeacher()"
                    >
                      送出修改
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-tab>
      <b-tab title="教師帳號匯入">
        上傳編碼UTF-8 附檔.csv檔案格式如下(含欄位名稱):<a href="teacher.csv"
          >下載範例檔</a
        ><br />
        <table class="table" style="width: auto; align: left">
          <tbody>
            <tr>
              <td>教師帳號(身分證字號)</td>
              <td>姓名</td>
              <td>服務單位</td>
              <td>職稱</td>
              <td>連絡電話</td>
              <td>Email</td>
            </tr>

            <tr>
              <td>A123456789</td>
              <td>OOO</td>
              <td>電子系</td>
              <td>副教授</td>
              <td>0911111111</td>
              <td>xxx@ncut.edu.tw</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 1em" colspan="6">
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  v-model="file[0]"
                  @input="fileChange(0)"
                  placeholder="上傳csv檔案"
                  accept=".csv"
                ></b-form-file>

                <button
                  href="#"
                  @click.prevent="BatchAddTeacher()"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  送出
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import * as tools from '../tool'

export default {
  name: 'AddTeacher',
  data () {
    return {
      file: [{ name: '' }],
      inputData: {
        tid: '',
        idNo: '',
        name: '',
        jobTitle: '',
        serviceUnit: '',
        cellPhone: '',
        email: ''
      }
    }
  },
  computed: {},
  methods: {
    BatchAddTeacher () {
      var vm = this
      if (vm.file[0].name == '') {
        alert('請上傳csv檔案')
        return
      }

      this.$http
        .get('./WebApi/ociaRep/BatchAddTeacher')
        .then((response) => {
          if (response.data > 0) {
            tools.showAlert(vm, 'success', '匯入檔案成功')
          } else {
            tools.showAlert(vm, 'danger', '匯入檔案失敗，請重新上傳' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗，請重新匯入檔案' + error)
        })
    },

    fileChange (index) {
      var vm = this
      this.formData = new FormData()

      if (index == 0) this.formData.append('header', this.file[0])

      this.$http
        .post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) {
              this.file[0] = response.data[0]
            }
          } else {
            tools.showAlert(vm, 'danger', '上傳檔案失敗，請重新上傳' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗，請重新上傳' + error)
        })
    },

    close () {
      this.$emit('hideModal')
    },
    isEmpty (data) {
      return !(data != null && data != undefined && data.length > 0)
    },
    checkSaveData () {
      var msg = ''

      if (this.isEmpty(this.inputData.idNo)) {
        msg = '請輸入教師帳號(身分證字號)'
      } else if (this.isEmpty(this.inputData.name)) {
        msg = '請輸入姓名'
      } else if (this.isEmpty(this.inputData.jobTitle)) {
        msg = '請輸入職稱'
      } else if (this.isEmpty(this.inputData.serviceUnit)) {
        msg = '請輸入服務單位'
      } else if (this.isEmpty(this.inputData.cellPhone)) {
        msg = '請輸入連絡電話'
      } else if (this.isEmpty(this.inputData.email)) {
        msg = '請輸入Email'
      }

      return msg
    },

    AddociaRepTeacher: function () {
      var msg = this.checkSaveData()
      if (msg.length != 0) {
        alert(msg)
        return null
      }

      const vm = this

      this.$http
        .put('./WebApi/ociaRep/AddociaRepTeacher/', this.inputData)
        .then((response) => {
          if (response.data > 0) {
            tools.showAlert(vm, 'success', '恭喜您,存檔成功')
            this.close()
          } else {
            alert('修改失敗!!')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    }

  },
  created () {
    console.log('======created View =====')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
